import React from "react";
import { Form } from "react-bootstrap";
import AccordianCard from "../../../../../../accordion-card/accordian-card";
import {
  editItemInFieldArray,
  pushItemToFieldArray,
  removeItemFromFieldArray,
} from "../../../helpers";
import "../../../pitch-deck-analysis.css";
import PitchDeckTable from "../../pitch-deck-table/pitch-deck-form-table";
import FormCellMultiInput from "../../form/form-cell-multi-input";
import ResultsSection from "../results-section";

const CreateEditOperations = (props) => {
  props = {
    ...props,
    pushItemToFieldArray,
    removeItemFromFieldArray,
    editItemInFieldArray,
  };

  return (
    <div className="ideacheckertabbody">
      <div className="ideacheckerquestions">
        <AccordianCard
          title="Traction"
          activeKey="traction"
          className="companyaccordion"
        >
          <div className="ideacheckerscrollablediv">
            <Form>
              <Form.Group className="inputgroup">
                <FormCellMultiInput
                  props={props}
                  actualName="kpiMetrics"
                  displayName="What is your traction (KPI metrics)?"
                />
                <FormCellMultiInput
                  props={props}
                  actualName="metricsThatShowAchievement"
                  displayName="What are the traction metrics that show what you
                              have achieved so far?"
                />
                <FormCellMultiInput
                  props={props}
                  actualName="growthRate"
                  displayName="What are the week-over-week or month-over-month
                              growth rate?"
                />
                <FormCellMultiInput
                  props={props}
                  actualName="proofOfLatentDemand"
                  displayName="Is there proof of latent demand?"
                />
                <FormCellMultiInput
                  props={props}
                  actualName="isBusinessGrowing"
                  displayName="Is your business growing?"
                />
                <FormCellMultiInput
                  props={props}
                  actualName="isProductSelfPerpetuatingGrowth"
                  displayName="Is your product-or-service self-perpetuating its
                              growth?"
                />
                <FormCellMultiInput
                  props={props}
                  actualName="ableToAccomplishWithLess"
                  displayName="Have you been able to accomplish with less money
                              in less time?"
                />

                {/* operations form table */}

                <PitchDeckTable
                  props={props}
                  rowArray={[
                    {
                      type: "bodyHeaderCenter",
                      displayName: "PRODUCT-MARKET FIT",
                    },
                    {
                      fieldName: "percentCustWillBeDisappointed",
                      displayName: `Percentage of surveyed customers who indicate "much disappointment" if they no longer have access to your product`,
                      bottomText: "Enter value (in percentage)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "BOUNCE RATE",
                    },
                    {
                      fieldName: "bounceRate",
                      displayName:
                        "Percentage of visitors to your website who navigate away after viewing only one page",
                      bottomText: "Enter value (in percentage)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "TIME ON SITE",
                    },
                    {
                      fieldName: "timeOnSite",
                      displayName: "Time visitors spent on your website",
                      bottomText: "Enter time (in seconds)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "PAGES PER VISIT",
                    },
                    {
                      type: "warning",
                      fieldNames: ["numPageViews", "numSessions"],
                    },
                    {
                      fieldName: "numPageViews",
                      displayName: "Total no. of page views",
                      bottomText: "Enter value",
                    },
                    {
                      fieldName: "numSessions",
                      displayName: "Total no. of sessions",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "RETURNING VISITORS RATE",
                    },
                    {
                      type: "warning",
                      fieldNames: ["numRepeatVisitors", "totalNumUniqueVisitors"],
                    },
                    {
                      fieldName: "numRepeatVisitors",
                      displayName:
                        "No. of repeat visitors to your site in a specific time period",
                      bottomText: "Enter value",
                    },
                    {
                      fieldName: "totalNumUniqueVisitors",
                      displayName:
                        "Total no. of unique visitors to your site in a specific time period",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "SOCIAL MEDIA ENGAGEMENT RATE",
                    },
                    {
                      type: "warning",
                      fieldNames: ["totalNumEngagements", "totalNumFollowers"],
                    },
                    {
                      fieldName: "totalNumEngagements",
                      displayName: "Total no. of engagements",
                      bottomText: "Enter value",
                    },
                    {
                      fieldName: "totalNumFollowers",
                      displayName: "Total no. of followers",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "MARKETING RETURN ON INVESTMENT (ROI)",
                    },
                    {
                      type: "warning",
                      fieldNames: [
                        "netSalesPriorPeriod",
                        "netSalesCurrentPeriod",
                      ],
                    },
                    {
                      fieldName: "netSalesPriorPeriod",
                      displayName: "Net sales for the prior period",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      fieldName: "netSalesCurrentPeriod",
                      displayName: "Net sales for the current period",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      fieldName: "marketingCost",
                      displayName: "Cost of marketing",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "ACTIVE USERS",
                    },
                    {
                      type: "warning",
                      fieldNames: [
                        "numDailyActiveUsers",
                        "numMonthlyActiveUsers",
                      ],
                    },
                    {
                      fieldName: "numDailyActiveUsers",
                      displayName: "No. of daily active users",
                      bottomText: "Enter value",
                    },
                    {
                      fieldName: "numMonthlyActiveUsers",
                      displayName: "No. of monthly active users",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "CUSTOMER ACQUISITION COST (CAC)",
                    },
                    {
                      fieldName: "custAcquisitionCost",
                      displayName:
                        "Amount of money your company spends to get a new customer",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "QUALIFIED LEADS",
                    },
                    {
                      type: "warning",
                      fieldNames: ["numQualifiedLeads", "numPotentialCustomers"],
                    },
                    {
                      fieldName: "numQualifiedLeads",
                      displayName: "No. of qualified leads",
                      bottomText: "Enter value",
                    },
                    {
                      fieldName: "numPotentialCustomers",
                      displayName: "No. of potential customers",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "TIME ON PAGE",
                    },
                    {
                      fieldName: "timeOnPage",
                      displayName:
                        "Time user spent on a particular page on your website",
                      bottomText: "Enter time (in seconds)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "CONVERSION RATE",
                    },
                    {
                      type: "warning",
                      fieldNames: ["numConvertedUsers", "audienceSize"],
                    },
                    {
                      fieldName: "numConvertedUsers",
                      displayName: "No. of converted users",
                      bottomText: "Enter value",
                    },
                    {
                      fieldName: "audienceSize",
                      displayName: "Size of audience",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "USER RETENTION",
                    },
                    {
                      type: "warning",
                      fieldNames: [
                        "numUsersOfProductOnSpecificDay",
                        "numUsersOfProductOnFirstDay",
                      ],
                    },
                    {
                      fieldName: "numUsersOfProductOnSpecificDay",
                      displayName:
                        "No. of users who used your product on a specific day",
                      bottomText: "Enter value",
                    },
                    {
                      fieldName: "numUsersOfProductOnFirstDay",
                      displayName:
                        "No. of users who used your product on the first day",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "CHURN RATE",
                    },
                    {
                      type: "warning",
                      fieldNames: ["numLostCust", "numCustAtStart"],
                    },
                    {
                      fieldName: "numLostCust",
                      displayName: "No. of customers lost",
                      bottomText: "Enter value",
                    },
                    {
                      fieldName: "numCustAtStart",
                      displayName: "No. of customers at the start",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "TRAFFIC-TO-LEAD RATIO",
                    },
                    {
                      type: "warning",
                      fieldNames: ["numWebsiteVisitors", "numLeads"],
                    },
                    {
                      fieldName: "numWebsiteVisitors",
                      displayName: "No. of visitors to your website",
                      bottomText: "Enter value",
                    },
                    {
                      fieldName: "numLeads",
                      displayName: "No. of visitors who are leads",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "ORDER FULFILLMENT RATE",
                    },
                    {
                      type: "warning",
                      fieldNames: [
                        "totalNumOrdersReceived",
                        "numOrdersProcessed",
                      ],
                    },
                    {
                      fieldName: "numOrdersProcessed",
                      displayName: "No. of processed orders",
                      bottomText: "Enter value",
                    },
                    {
                      fieldName: "totalNumOrdersReceived",
                      displayName: "Total no. of orders received",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "EMPLOYEE SATISFACTION RATING",
                    },
                    {
                      fieldName: "employeeSatisfactionRating",
                      displayName: "Employee satisfaction rating",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "CUSTOMER RETENTION RATE",
                    },
                    {
                      fieldName: "custRetentionRate",
                      displayName:
                        "No. of customers a company retains over a given period of time",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "MONTHLY RECURRING REVENUE (MRR)",
                    },
                    {
                      type: "warning",
                      fieldNames: ["totalNumPayingusers", "avRevenuePerUser"],
                    },
                    {
                      fieldName: "totalNumPayingusers",
                      displayName: "Total no. of paying users",
                      bottomText: "Enter value",
                    },
                    {
                      fieldName: "avRevenuePerUser",
                      displayName: "Average revenue per user (ARPU)",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "NET MRR GROWTH RATE",
                    },
                    {
                      type: "warning",
                      fieldNames: ["netMRRPreviousMonth", "netMRRCurrentMonth"],
                    },
                    {
                      fieldName: "netMRRPreviousMonth",
                      displayName: "Net MRR of the previous month",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      fieldName: "netMRRCurrentMonth",
                      displayName: "Net MRR of the current month",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "NET MRR CHURN RATE",
                    },
                    {
                      type: "warning",
                      fieldNames: [
                        "contractionMRR",
                        "expansionMRR",
                        "MRRAtStart",
                      ],
                    },
                    {
                      fieldName: "contractionMRR",
                      displayName:
                        "Total reduction in MRR due to downgrades and subscription cancellations (or churn) compared to the previous month (contraction MRR)",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      fieldName: "expansionMRR",
                      displayName:
                        "Additional MRR generated in the current month compared to the previous month, excluding the MRR contributed by new customers/new MRR",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      fieldName: "MRRAtStart",
                      displayName: "MRR at the start",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "GROSS MRR CHURN RATE",
                    },
                    {
                      type: "warning",
                      fieldNames: [
                        "totalMRRChurnThisMonth",
                        "totalMRRAtStartThisMonth",
                      ],
                    },
                    {
                      fieldName: "totalMRRChurnThisMonth",
                      displayName: "Total MRR churn in the current month",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      fieldName: "totalMRRAtStartThisMonth",
                      displayName: "Total MRR at the start of the current month",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "EMPLOYEES",
                    },
                    {
                      fieldName: "numEmployees",
                      displayName:
                        "No. of employees in your company/organization",
                      bottomText: "Enter value",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "FUNDING",
                    },
                    {
                      fieldName: "fundingValue",
                      displayName: "Funding value",
                      bottomText: "Enter amount (in USD)",
                      unitName: "fundingUnit",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "ANNUAL RECURRING REVENUE (ARR)",
                    },
                    {
                      fieldName: "ARRValue",
                      displayName:
                        "Subscription economy metric that shows the money that comes in every year for the life of a subscription/contract",
                      bottomText: "Enter amount (in USD)",
                      unitName: "ARRUnit",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "SALES & MARKETING SPEND",
                    },
                    {
                      fieldName: "salesAndMarketingSpend",
                      displayName:
                        "Total internal and external expenses incurred that are directly and indirectly related to selling and marketing your product/service",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "RESEARCH & DEVELOPMENT SPEND",
                    },
                    {
                      fieldName: "researchAndDevSpend",
                      displayName:
                        "Basic measure that covers intramural expenditure",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "CAC PAYBACK PERIOD",
                    },
                    {
                      fieldName: "cacPaybackPeriodInMonths",
                      displayName:
                        "Time taken for your company to earn back your CAC",
                      bottomText: "Enter value (in months)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "GROSS DOLLAR RETENTION",
                    },
                    {
                      fieldName: "grossDollarRetention",
                      displayName:
                        "Amount of recurring revenue retained from existing customers in a defined time period, including downgrades and cancellations, excluding any expansion revenue",
                      bottomText: "Enter amount (in USD)",
                    },
                    {
                      type: "rowBreak",
                    },
                    {
                      type: "bodyHeaderCenter",
                      displayName: "NET DOLLAR RETENTION",
                    },
                    {
                      fieldName: "netDollarRetention",
                      displayName:
                        "Amount of ARR/MRR which has grown or shrunk over time by factoring in customer expansion as well as negative churn and downgrades",
                      bottomText: "Enter amount (in USD)",
                    },
                  ]}
                />
              </Form.Group>
            </Form>
          </div>
        </AccordianCard>
      </div>

      <ResultsSection data={props.state.analysisResult} type="operations" />
    </div>
  );
};

export default CreateEditOperations;
